import { RestClient } from './RestClient'

export class StripePaymentsClient extends RestClient {
  /**
   * Show the specified customers
   *
   * @param {string} id - Stripe payment id
   *
   * @returns {AxiosPromise}
   */
  get (id) {
    return this.call('get', `stripe-payments/${id}`)
  }
}
